import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M17.25 6.5C17.25 6.08579 16.9142 5.75 16.5 5.75C16.0858 5.75 15.75 6.08579 15.75 6.5V17.5C15.75 17.9142 16.0858 18.25 16.5 18.25C16.9142 18.25 17.25 17.9142 17.25 17.5V6.5ZM7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L10.9393 12L6.46967 16.4697C6.17678 16.7626 6.17678 17.2374 6.46967 17.5303C6.76256 17.8232 7.23744 17.8232 7.53033 17.5303L12.5303 12.5303C12.8232 12.2374 12.8232 11.7626 12.5303 11.4697L7.53033 6.46967Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
